(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6885],{

/***/ 17812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(classes.root, className, color !== 'default' && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 44203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledContainer",
  componentId: "sc-mrb9q4-0"
})(["display:", ";position:fixed;z-index:1500;margin:0 auto;width:100%;", "{top:10px;}"], function (p) {
  return p !== null && p !== void 0 && p.hidden ? "none" : "block";
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledNavContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "KeyboardNavigation__StyledNavContainer",
  componentId: "sc-mrb9q4-1"
})(["padding:15px;background:", ";border:3px solid ", ";border-radius:3px;"], function (p) {
  return p.theme.colors.grey;
}, function (p) {
  return p.theme.colors.cherryRed;
});
var StyledDescription = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "KeyboardNavigation__StyledDescription",
  componentId: "sc-mrb9q4-2"
})(["text-align:center;font-size:25px;margin:0;padding:0;"]);

var KeyboardNavigation = function KeyboardNavigation(_ref) {
  var refList = _ref.refList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      hideNav = _useState[0],
      setHideNav = _useState[1]; // Ensures that this component will only show once


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      seenOnce = _useState2[0],
      setSeenOnce = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleKeyDown(e) {
      if (!(e !== null && e !== void 0 && e.key) || seenOnce) return;

      if (e.key === "Tab") {
        e.preventDefault();

        if (hideNav) {
          setHideNav(false);
          return;
        }

        if (!hideNav) {
          setSeenOnce(true);
          setHideNav(true);
          return;
        }
      }

      if (!hideNav && e.key === "Enter") {
        var _refList$, _refList$$current, _refList$2, _refList$2$current;

        (_refList$ = refList[0]) === null || _refList$ === void 0 ? void 0 : (_refList$$current = _refList$.current) === null || _refList$$current === void 0 ? void 0 : _refList$$current.scrollIntoView();
        (_refList$2 = refList[0]) === null || _refList$2 === void 0 ? void 0 : (_refList$2$current = _refList$2.current) === null || _refList$2$current === void 0 ? void 0 : _refList$2$current.focus();
        setSeenOnce(true);
        setHideNav(!hideNav);
      } // Old code that allowed you to navigate to different blocks
      // matches digits 0 - 9
      // if (!hideNav && e.key.match(/^\d+$/)) {
      // refList[e.key - 1]?.current?.scrollIntoView()
      // refList[e.key - 1]?.current?.focus()
      // }

    }

    document.addEventListener("keydown", handleKeyDown); // Clean up event

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [hideNav]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
    hidden: hideNav,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledNavContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDescription, {
        children: "\u05D3\u05DC\u05D2 \u05DC\u05EA\u05D5\u05DB\u05DF"
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (KeyboardNavigation);

/***/ }),

/***/ 14088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91315);
/* harmony import */ var common_SeoMetaData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31353);
/* harmony import */ var components_KeyboardNavigation_KeyboardNavigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44203);
/* harmony import */ var components_OtpStep_OtpPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80865);
/* harmony import */ var components_PurchasePage_Preview_Payment_PaymentContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79625);
/* harmony import */ var components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33574);
/* harmony import */ var components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98968);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var _payment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);















var seo = {
  title: "Quick Purchase SEO Title",
  description: "Quick Purchase SEO Description",
  keywords: "Quick Purchase SEO Keywords"
};

var QuickPurchaseOtp = function QuickPurchaseOtp() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)([]),
      refList = _useState[0];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false),
      loader = _useState2[0],
      setLoader = _useState2[1];

  void loader;

  var _useQuickPurchaseCont = (0,components_QuickPurchasePage_QuickPurchaseContext__WEBPACK_IMPORTED_MODULE_7__/* .useQuickPurchaseContext */ .Nr)(),
      quickPurchaseInputValues = _useQuickPurchaseCont.quickPurchaseInputValues,
      setPrevPath = _useQuickPurchaseCont.setPrevPath;

  var RecipientEmail = quickPurchaseInputValues.RecipientEmail,
      RecipientMobilePhone = quickPurchaseInputValues.RecipientMobilePhone,
      RecipientName = quickPurchaseInputValues.RecipientName,
      SenderEmail = quickPurchaseInputValues.SenderEmail,
      SenderLastName = quickPurchaseInputValues.SenderLastName,
      SenderMobilePhone = quickPurchaseInputValues.SenderMobilePhone,
      SenderName = quickPurchaseInputValues.SenderName,
      amount = quickPurchaseInputValues.amount,
      checkedTwo = quickPurchaseInputValues.checkedTwo;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();

  var _usePurchaseContext = (0,components_PurchasePage_PurchaseContext__WEBPACK_IMPORTED_MODULE_6__/* .usePurchaseContext */ .AX)(),
      setOrderId = _usePurchaseContext.setOrderId,
      setOrderRecipientGuid = _usePurchaseContext.setOrderRecipientGuid;

  var _usePaymentContext = (0,components_PurchasePage_Preview_Payment_PaymentContext__WEBPACK_IMPORTED_MODULE_5__/* .usePaymentContext */ .JL)(),
      setPaymentSteps = _usePaymentContext.setPaymentSteps;

  var createOrder = /*#__PURE__*/function () {
    var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var _data$body, _data$body2;

      var orderData, _yield$postGiftCardQu, data, orderId, orderRecipientGuid;

      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              orderData = {
                quantity: 1,
                amount: amount,
                phoneNumber: RecipientMobilePhone,
                recipientName: RecipientName,
                recipientEmail: RecipientEmail,
                senderName: SenderName,
                senderLastName: SenderLastName,
                senderMobilePhone: SenderMobilePhone,
                senderEmail: SenderEmail,
                senderBlessing: "",
                approveMarketingContent: checkedTwo || false
              };
              _context.next = 3;
              return (0,api__WEBPACK_IMPORTED_MODULE_1__.postGiftCardQuickPurchaseCreateOrder)(orderData);

            case 3:
              _yield$postGiftCardQu = _context.sent;
              data = _yield$postGiftCardQu.data;
              orderId = data === null || data === void 0 ? void 0 : (_data$body = data.body) === null || _data$body === void 0 ? void 0 : _data$body.orderId;
              orderRecipientGuid = data === null || data === void 0 ? void 0 : (_data$body2 = data.body) === null || _data$body2 === void 0 ? void 0 : _data$body2.orderRecipientGuid;
              setOrderId(orderId);
              setOrderRecipientGuid(orderRecipientGuid);
              router.replace("/quick-purchase/payment");
              setPaymentSteps(_payment__WEBPACK_IMPORTED_MODULE_10__.PaymentSteps.PAYMENT);
              setLoader(false);
              setPrevPath("/quick-purchase");

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createOrder() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_KeyboardNavigation_KeyboardNavigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      refList: refList
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(common_SeoMetaData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
      data: seo
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_OtpStep_OtpPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      prevPathLink: "/quick-purchase",
      editLink: "/quick-purchase",
      type: "purchase",
      submit: /*#__PURE__*/function () {
        var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(success) {
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (success) {
                    createOrder();
                  } else {
                    console.log("FAILURE");
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (QuickPurchaseOtp);

/***/ }),

/***/ 65637:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quick-purchase/otp",
      function () {
        return __webpack_require__(14088);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2726,3450,2198,2663,3818,3588,4055,1456,9904,8643,2563,3050,865,9774,2888,179], function() { return __webpack_exec__(65637); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);